<template>
    <!-- 代理出口证明 -->
    <div class="export-certificate-list">
        <ab-list-query :tabs="tabs" @handleSelect="handleSelect" @handleTabs='selectMenu' :isActive="isActive">
            <template #right>
                <el-row :gutter="20">
                    <el-col :span="4">
                        <el-input
                            placeholder="订单号"
                            v-model.trim="formSearch.custOrderNo"
                            clearable
                        >
                        </el-input>
                    </el-col>

                    <el-col :span="4">
                        <el-input
                            placeholder="报关单号"
                            v-model.trim="formSearch.coreBillNumOrBgNum"
                            clearable
                        >
                        </el-input>
                    </el-col>

                    <el-col :span="4">
                        <ab-select
                            url="/bas/client/basCustomer/list"
                            placeholder="境外客户"
                            inputKey="name"
                            descKey="name"
                            isNotClear
                            v-model="formSearch.customerIdDesc"
                            :urlData="{pageNum: 1, pageSize: 10, data: {},}"
                            @handleSelect="bankChange"
                        >
                        </ab-select>
                    </el-col>

                    <el-col :span="4" class="text-left">
                        <el-button @click="getDataList">搜索</el-button>
                        <el-button link class="btn-svg" @click="formSearch = {status: status }">
                            <ab-svg name="qingchu"></ab-svg>
                            清除
                        </el-button>
                    </el-col>
                </el-row>
            </template>

            <template #toolbar>
                <el-button v-if="isActive == '2' && $isAuth('settlement:tax:apply:export')" @click="exportFileAlready" style="border-left: 1px solid #dbdfe6" :loading="exportAlreadyLoad">
                    导 出
                </el-button>
            </template>

            <template #table>
                <!-- 待申请 -->
                <ab-table
                    v-if="isActive == '1'"
                    stripe
                    class="materialTable"
                    ref="table"
                    :column-list="columns"
                    indexWidth="50"
                    widths="120"
                    isFilter="operator"
                    :dataListLoading="tableLoading"
                    :table-list="tableData"
                    @filterColumns="filterColumns"
                    :handleSelectionChange="handleSelectionChange"
                >
                    <template #number="{row}">
                        <span class="font-primary" @click="showDialog(row)">{{row.number}}</span>
                    </template>

                    <template #isTaxRebateDeclara="{row}">
                        <p>{{row.isTaxRebateDeclara == '01'? '是' : '否'}}</p>
                    </template>

                    <template #attachStatus="{row}">
                        <el-tooltip
                            v-if="row.attachStatus == '04'"
                            class="item"
                            effect="dark"
                            :content="getWord(row.lackAttach)"
                            placement="top"
                        >
                            <p style="color: red; text-align: center">缺</p>
                        </el-tooltip>
                        <p v-else style="text-align: center">齐</p>
                    </template>
                </ab-table>

                <!-- 已申请 -->
                <ab-table
                   v-else
                    stripe
                    class="materialTable"
                    ref="table"
                    :column-list="columns1"
                    indexWidth="50"
                    widths="180"
                    isFilter="operator"
                    :dataListLoading="tableLoading"
                    :table-list="tableData"
                    @filterColumns="filterColumns1"
                >
                    <template #number="{row}">
                        <span class="font-primary" @click="showDialog(row)">{{row.number}}</span>
                    </template>

                    <template #isTaxRebateDeclara="{row}">
                        <p>{{row.isTaxRebateDeclara == '01'? '是' : '否'}}</p>
                    </template>

                    <template #attachStatus="{row}">
                        <el-tooltip
                            v-if="row.attachStatus == '04'"
                            class="item"
                            effect="dark"
                            :content="row.lackAttach.join()"
                            placement="top"
                        >
                            <p style="color: red; text-align: center">缺</p>
                        </el-tooltip>
                        <p v-else style="text-align: center">齐</p>
                    </template>
                </ab-table>

            </template>

            <template #page>
                <!-- <div class="filterColumnsList">
                    已选条目：<text>{{selectList.length}}</text>条
                </div> -->
                <ab-page
                    :pageTotal="page.total"
                    :currentPage="page.currentPage"
                    :pageSize="page.pageSize"
                    :pageSizes="page.pageSizes"
                    @searchForm="searchForm"
                ></ab-page>
            </template>
        </ab-list-query>

        <!-- 弹框 -->
        <el-dialog
            title="代理出口证明详情"
            v-model="dialogVisible"
            class="goodsCerti"
            width="70%"
            :close-on-click-modal="false"
            :before-close="handleClose"
        >
            <div class="topName">
                NO: {{formData.number}}
            </div>
            <div class="money">
                <div class="hd">总报关金额</div>
                <div class="number">
                    {{$filters.formatMoney(formData.declTotal)}}
                    <span>({{formData.applyCurrencyIdDesc}})</span>
                </div>
            </div>
            <!-- 导出 -->
            <div class="table-toolber" v-if="$isAuth('settlement:tax:apply:exportSu')">
                <el-button type="primary" @click="exportFile" :loading="btnLoading">
                    导出
                </el-button>
            </div>
            <ab-table
                showOrder
                :column-list="columns2"
                indexWidth="50"
                widths="180"
                :dataListLoading="tableLoading"
                :table-list="tableData2"
            >
                <template #portDate="{row}">
                    <span >{{row.portDate.split(' ')[0]}}</span>
                </template>
            </ab-table>

            <div class="list-page">
                <ab-page
                    :pageTotal="page2.total"
                    :currentPage="page2.currentPage"
                    :pageSize="page2.pageSize"
                    :pageSizes="page2.pageSizes"
                    @searchForm="getdataList2"
                ></ab-page>
            </div>

            <template #footer>
                <el-button @click="handleClose" style="border-left: 1px solid #dbdfe6" >
                    取 消
                </el-button>
            </template>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: 'export-certificate-list',
    data() {
        return {
            isActive: '1',
            tableLoading: false,
            btnLoading: false,
            exportAlreadyLoad: false,
            tabs: [
                { name: "待申请", value: "", state: "1" },
                { name: "已申请", value: "", state: "2" },
            ],
            status: 1,
            formSearch: {
                status: 1,
            },
            id: '',
            tableData: [],
            dialogVisible: false,
            //弹框数据
            selectData: {},
            selectList: [],
            // 弹窗总报关金额
            tableData2: [],
            formData: {},
            columns: [
                {
                    props: "number",
                    labels: "申请单号",
                    widths: 110,
                    slot: 'slot'
                },
                {
                    props: "custOrderNo",
                    labels: "订单编号",
                    widths: 90,
                },
                {
                    props: "customsDeclarationNumber",
                    labels: "报关单号",
                    widths: 90,
                },
                {
                    props: "isTaxRebateDeclara",
                    labels: "代退税申报",
                    widths: 70,
                    slot: 'slot'
                },
                {
                    props: "customsPrice",
                    labels: "总报关金额",
                    widths: 80,
                },
                {
                    props: "currencyName",
                    labels: "币别",
                    widths: 40,
                },
                {
                    props: "abroadCustomsName",
                    labels: "境外客户",
                    widths: 90,
                },
                {
                    props: "attachStatus",
                    labels: "申报材料",
                    widths: 50,
                    slot: "slot",
                },
            ],
            columns1: [
                {
                    props: "number",
                    labels: "申请单号",
                    widths: 110,
                    slot: 'slot'
                },
                {
                    props: "custOrderNo",
                    labels: "订单编号",
                    widths: 90,
                },
                {
                    props: "coreBillNumber",
                    labels: "系统单号",
                    widths: 90
                },
                {
                    props: "customsDeclarationNumber",
                    labels: "报关单号",
                    widths: 90,
                },
                {
                    props: "isTaxRebateDeclara",
                    labels: "代退税申报",
                    widths: 60,
                    slot: 'slot'
                },
                {
                    props: "customsPrice",
                    labels: "报关金额",
                    widths: 70,
                    type: 'money',
                    align: 'right',
                },
                {
                    props: "currencyName",
                    labels: "币别",
                    widths: 40,
                },
                {
                    props: "abroadCustomsName",
                    labels: "境外客户",
                    widths: 100,
                },
                {
                    props: "trusteeName",
                    labels: "经营单位",
                    widths: 120,
                },
                {
                    props: "updateByName",
                    labels: "操作人",
                    widths: 70,
                },
                {
                    props: "updateTime",
                    labels: "操作时间",
                    widths: 110,
                },
            ],
            columns2: [
                {
                    props: "customsDeclarationNumber",
                    labels: "报关单号",
                    widths: 80,
                },
                {
                    props: "portDate",
                    labels: "出口日期",
                    widths: 120,
                    slot: 'slot'
                },
                {
                    props: "codeTS",
                    labels: "海关编码",
                    widths: 80,
                },
                {
                    props: "gname",
                    labels: "商品名称",
                    widths: 100,
                },
                {
                    props: "unitDesc",
                    labels: "单位",
                    widths: 100,
                },
                {
                    props: "gqty",
                    labels: "数量",
                    widths: 100,
                },
                {
                    props: "currencyName",
                    labels: "币别",
                    widths: 40,
                },
                {
                    props: "declTotal",
                    labels: "报关价格",
                    widths: 110,
                },
                {
                    props: "protocolNumber",
                    labels: "协议号",
                    widths: 110,
                },
            ],
            page: {
                currentPage: 1,
                pageSize: 10,
                pageSizes: [10, 20, 50, 100],
                total: 0,
            },
            page2: {
                currentPage: 1,
                pageSize: 10,
                pageSizes: [10, 20, 50, 100],
                total: 0,
            },
        }
    },
    created(){
        this.getDataList()
    },
    methods: {
        getWord(val){
            let name = ''
            if(val){
                val.forEach((e)=>{
                    name = name + e
                })
            }
            return name
        },
        getDataList(){
            this.searchForm()
        },
        searchForm(pages) {
            if(pages){
                this.page.currentPage = pages.currentPage
                this.page.pageSize = pages.pageSize
            }
            this.tableLoading = true;
            let data = Object.assign({}, this.formSearch, { viewFlag: 0 });
            this.$post("/fms/taxRebateProveApply/client/list", {
                data,
                pageNum: this.page.currentPage,
                pageSize: this.page.pageSize,
            }).then(({ data }) => {
                if (data.code === "C0000") {
                    this.tableData = data.result.list;
                    this.page.total = data.result.total;
                    if(this.isActive == 1){
                        this.tabs[0].value = data.result.total
                    }
                } else {
                    this.$message.error(data.message);
                }
            }).finally(() => {
                this.tableLoading = false;
            });
        },
        //待申请
        filterColumns(val){
            this.columns = val
        },
        //已申请
        filterColumns1(val){
            this.columns1 = val
        },
        selectMenu(val){
            this.initialize()
            this.status = val
            this.formSearch.status = val
            this.isActive = val
            this.searchForm()
        },
        //初始化
        initialize(){
            this.tableData = []
            this.formSearch = {}
            this.page.currentPage = 1
            this.page.total = 0
            this.selectList = []
        },
        //选择境外客户
        bankChange(val){
            this.formSearch.abroadCustomsId = val.id
        },
        //多选框
        handleSelectionChange(val){
            this.selectList = val
        },
        getdataList2(page){
            if(page){
                this.page2.currentPage = page.currentPage
                this.page2.pageSize = page.pageSize
                this.showDialog()
            }   
        },
        //弹框
        showDialog(row){
            this.dialogVisible = true
            //保存数据
            this.selectData = row

            this.id = row.id || this.selectData.id
            let data = { id: this.id };
            this.$post("/fms/taxRebateProveApplyEntry/listByParentId", { 
                data,
                pageNum: this.page2.currentPage,
                pageSize: this.page2.pageSize,
             }).then(({ data }) => {
                if (data.code === "C0000") {
                    this.tableData2 = data.result.list;
                    this.page2.total = data.result.total
                    this.formData.declTotal = row.customsPrice || 0;
                    this.formData.number = row.number || '';
                    this.formData.applyCurrencyId = row.currencyId || '';
                    this.formData.applyCurrencyIdDesc = row.currencyNumber || '';
                }
            }) .finally(() => {
                this.tableLoading = false;
            });
        },
        //弹框关闭
        handleClose(){
            this.id = ''
            this.tableData2 = []
            this.selectData = {}
            this.page2.currentPage = 1
            this.dialogVisible = false
        },
        //导出
        exportFile() {
            this.btnLoading = true
            let id = this.id
            let excelField = [];
            this.columns2.forEach((ele) => {
                let a = ele.props;
                if (a == "gname") {
                    a = "gName";
                }
                if (a == "gunit") {
                    a = "gUnit";
                }
                if (a == "gqty") {
                    a = "gQty";
                }
                excelField.push(a);
            });
            let data = { data: { id, parentId: id }, excelField };
            this.exportLoading = true;
            this.$http({
                url: this.$adornUrl('/fms/taxRebateProveApplyEntry/exportList'),
                method: "post",
                data,
            }).then((res) => {
                if (res && res.data.code === "C0000") {
                    // 创建隐藏的可下载链接
                    var eleLink = document.createElement("a");
                    eleLink.download = "";
                    eleLink.style.display = "none";
                    // 字符内容转变成blob地址
                    eleLink.href = res.data.message;
                    // 触发点击
                    document.body.appendChild(eleLink);
                    eleLink.click();
                    // 然后移除
                    document.body.removeChild(eleLink);
                    this.btnLoading = false
                } else {
                    this.$message.error(res.data.message);
                    this.btnLoading = false
                }
            }).catch((err) => {
                this.$message.error("服务器正忙，请稍后");
            }).finally(() => {
                this.exportLoading = false;
            });
        },
        //已申请报表导出
        exportFileAlready(){
            this.exportAlreadyLoad = true
            let excelField = [];
            this.columns1.forEach((ele) => {
                excelField.push(ele.props);
            });
            let data = this.formSearch;
            data.status = 2;
            data.viewFlag = 0;
            this.$post("/fms/taxRebateProveApply/exportList", {
                pageNum: this.page.currentPage,
                pageSize: this.page.pageSize,
                excelField,
                data,
            }).then((res) => {
                if (res && res.data.code === "C0000") {
                    // 创建隐藏的可下载链接
                    var eleLink = document.createElement("a");
                    eleLink.download = "";
                    eleLink.style.display = "none";
                    // 字符内容转变成blob地址
                    eleLink.href = res.data.message;
                    // 触发点击
                    document.body.appendChild(eleLink);
                    eleLink.click();
                    // 然后移除
                    document.body.removeChild(eleLink);
                } else {
                    this.$message.error(res.data.message);
                }
            }).catch((err) => {
                this.$message.error("服务器正忙，请稍后");
            }).finally(() => {
                this.exportAlreadyLoad = false;
            });
        }
    },
}
</script>

<style lang="scss">
    .export-certificate-list{
        .list-page{
            position: relative;
            .filterColumnsList{
                position: absolute;
                top: 18px;
                font-size: 14px;
                color: #000;
                text{
                    color: #FF0000;
                }
            }
        }
        
        .goodsCerti{
            position: relative;
            .topName{
                position: absolute;
                top: 0;
                left: 50%;
                transform: translateX(-50%);
                background-color: #F2F7FF ;
                padding: 5px 10px;
                border-radius: 0 0 8px 8px;
                font-size: 14px;
            }
            .money{
                width: 360px;
                background-color: #F2F7FF;
                border-radius: 8px;
                margin-bottom: 10px;
                padding: 12px 0 12px 20px;
                .hd{
                    font-size: 14px;
                    margin-bottom: 10px;
                }
                .number{
                    font-size: 36px;
                    color: #F87243;
                    span{
                        font-size: 14px;
                    }
                }
            }
            .table-toolber{
                margin-bottom: 10px;
            }
            .list-page {
                padding: 10px 0;
                .el-pagination {
                    justify-content: center;
                    .btn-prev, .btn-next {
                        width: 76px;
                        height: 36px;
                        border: 1px solid #C4C6CF;
                        background-color: #ffffff;
                        border-radius: 30px;
                        margin:0 10px;
                    }
                    .el-pager {
                        .number,
                        .btn-quickprev,
                        .btn-quicknext {
                            border: 1px solid #C4C6CF;
                            background-color: #ffffff;
                            border-radius: 50%;
                            height: 36px;
                            width:36px;
                            margin-right: 10px;
                        }
                        .is-active {
                            background-color: #0A7CFF;
                            color: #ffffff;

                        }
                    }

                    .el-pagination__sizes {
                        .el-input {
                            height: 36px;
                        }
                        .el-input__wrapper {
                            background-color: #ffffff;
                            border: 1px solid #C4C6CF;
                            border-radius: 30px;
                        }
                    }
                    .el-pagination__jump {
                        .el-input__wrapper {
                            background-color: #ffffff;
                            border: 1px solid #C4C6CF;
                            border-radius: 30px;
                        }
                    }
                    
                }
            }
        }
    }
</style>